export default __webpack_public_path__ + "static/media/empty-star.c445be79cec1bfb27761180ab1ba059a.svg";